export default __webpack_public_path__ + "static/2297-67729bcae9b6d87cc917979f2578402e.gif";